import text from '../text.json'
import {CircleErrorIcon} from '../../../../icons'
import {ImgButton} from '../../../core/button'
import {useSelector} from 'react-redux'
import TextHelper from '../../../../utils/text'
import LimitManager, {ENABLED_LIMIT_KEY, ENABLED_LIMIT_VALUE} from '../../../../utils/limitManager'

const VoucherModal = ({closeModal}) => {
    const voucherData = useSelector(state => state.voucher.voucherData)
    const voucherErrorMessage = useSelector(state => state.voucher.voucherErrorMessage)

    const customerLimits = LimitManager.getAllLimits()

    const keyToString = key => {
        return TextHelper.replaceAllChars(TextHelper.capitalizeFirstChar(key), '-', ' ')
    }

    const getLimitValue = (item) => {
        if (item.includes(ENABLED_LIMIT_KEY)) {
            return voucherData?.overridden_limits[item] === ENABLED_LIMIT_VALUE ? text.enabled : text.disabled
        }
        return voucherData?.overridden_limits[item]
    }

    const getCustomerLimit = key => {
        const value = customerLimits?.find(item => item?.key === key)?.value
        if (key.includes(ENABLED_LIMIT_KEY)) {
            return value === ENABLED_LIMIT_VALUE ? text.enabled : text.disabled
        }
        return value
    }
    const isRowVisible = key => {
        return voucherData.overridden_limits[key] !== customerLimits.find(item => item?.key === key)?.value
    }

    const getTableBody = () => {
        return Object.keys(voucherData.overridden_limits).map((item, index) => {
            return isRowVisible(item) && (
                <tr key={index}>
                    <td>{keyToString(item)}</td>
                    <td>
                        <span className="line-throw">{getCustomerLimit(item)}</span>
                    </td>
                    <td>
                        <span
                            className="fade">{getLimitValue(item)}</span>
                    </td>
                </tr>
            )
        })
    }

    return <div className="modal-body">
        {Object.keys(voucherData).length !== 0 ? (
            <>
                <span className="gift-emoji">{text.has_voucher_emoji}</span>
                <span className="popup-message">{text.voucher_success_message}</span>
                <div className="voucher-data-container">
                    <div className="voucher-table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th>{text.service}</th>
                                    <th>{text.prev_limit}</th>
                                    <th>{text.new_limit}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getTableBody()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        ) : (
            <>
                <CircleErrorIcon/>
                <span className="popup-message">{voucherErrorMessage}</span>
            </>
        )
        }
        <ImgButton onClick={closeModal}>
            {text.ok}
        </ImgButton>
    </div>
}

export default VoucherModal
